import moment from "moment";
import React, { useState } from "react";
import InputColor from "../../../views/dashboard/settings/branding/InputColor";
import submit from "submit-form";
import DateInput from "../../inputs/date-input";
import Modal from "../../modal-new";

export const IndividualEventModal = ({
  eventId,
  eventName,
  eventDescription,
  eventFromDate,
  eventToDate,
  eventColor,
  athleteId,
  mode,
  organizationCoachId,
}) => {
  const [modeState, setModeState] = useState(mode);

  const [eventState, setEventState] = useState({
    eventId,
    eventName,
    eventDescription,
    eventFromDate,
    eventToDate,
    eventColor,
  });

  const {
    eventName: stateEventName,
    eventDescription: stateEventDescription,
    eventFromDate: stateEventFromDate,
    eventToDate: stateEventToDate,
    eventColor: stateEventColor,
  } = eventState;

  const handleRemoveEvent = () => {
    let body = { eventId, athleteId };

    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }

    submit(`/actions/annual-planner/remove-calendar-event`, {
      method: "POST",
      body,
    });
  };

  const handleChange = (input, payload) => {
    setEventState(Object.assign({}, eventState, { [input]: payload }));
  };

  const handleUpdate = () => {
    if (
      !stateEventName ||
      !stateEventColor ||
      !stateEventFromDate ||
      !stateEventDescription
    )
      return;

    let body = {
      eventId,
      eventName: stateEventName,
      eventDescription: stateEventDescription,
      eventFromDate: stateEventFromDate,
      eventToDate: stateEventToDate,
      eventColor: stateEventColor,
      athleteId,
    };

    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }

    submit(`/actions/annual-planner/update-calendar-event`, {
      method: "POST",
      body,
    });
  };

  const handleCancel = () => {
    setModeState("read");
    setEventState({
      eventId,
      eventName,
      eventDescription,
      eventFromDate,
      eventToDate,
      eventColor,
    });
  };

  return (
    <Modal
      className="annual-planner-modal individual-event-modal"
      toClear={"toDate=undefined"}
      title={
        modeState === "read"
          ? "Event detail"
          : modeState === "edit"
          ? "Edit event"
          : "Remove event"
      }
    >
      <div className="body">
        <form
          className="annual-planner-modal-form individual-event-modal-form"
          encType="multipart/form-data"
          id="individual-event-form"
        >
          {modeState === "remove" && (
            <span className="chip warning">
              You are about to remove the following event from your athlete.
              Please confirm.
            </span>
          )}

          <div role="wrapper" className="flex-row">
            <div role="wrapper" className="event-name">
              <label className="label">Event Name</label>

              {modeState === "edit" ? (
                <input
                  autoFocus
                  type={"text"}
                  name="eventName"
                  className="event-name"
                  placeholder="Enter title"
                  defaultValue={eventState.eventName}
                  onChange={({ target: { value } }) =>
                    handleChange("eventName", value)
                  }
                />
              ) : (
                <span className="event-name">{eventState.eventName}</span>
              )}
            </div>
            <div role="wrapper" className="event-color">
              <label className="label">Color</label>
              {modeState === "edit" ? (
                <InputColor
                  onChange={({ target: { value } }) =>
                    handleChange("eventColor", value)
                  }
                  value={eventState.eventColor}
                  customClassNames={"event-color"}
                />
              ) : (
                <InputColor
                  onlyRead
                  colorValueClassNames={"event-color-text"}
                  value={eventState.eventColor}
                  customClassNames={"event-color"}
                />
              )}
            </div>
          </div>
          <div role="wrapper" className="flex-row">
            <div role="wrapper" className="event-from">
              <label className="label">
                Date <span className="smooth">(from)</span>
              </label>
              {modeState === "edit" ? (
                <DateInput
                  customClassNames="event-from"
                  name="eventFrom"
                  defaultValue={moment(
                    eventState.eventFromDate,
                    "YYYYMMDD"
                  ).format("YYYY-MM-DD")}
                  forceOnChange={true}
                  onChange={(newDate) =>
                    handleChange(
                      "eventFromDate",
                      Number(moment(newDate, "MMM D, YYYY").format("YYYYMMDD"))
                    )
                  }
                />
              ) : (
                <span className="event-from">
                  {moment(eventState.eventFromDate, "YYYYMMDD").format(
                    "MMM D, YYYY"
                  )}
                </span>
              )}
            </div>
            <div role="wrapper" className="event-to">
              <label
                className={`label${
                  !!!eventState.eventFromDate ? " disabled" : ""
                }`}
              >
                Date <span className="smooth">(to)</span>
              </label>
              {modeState === "edit" ? (
                <DateInput
                  customClassNames="event-to"
                  name="eventTo"
                  defaultValue={
                    eventState.eventToDate &&
                    moment(eventState.eventToDate, "YYYYMMDD").format(
                      "YYYY-MM-DD"
                    )
                  }
                  forceOnChange={true}
                  disabled={!!!eventState.eventFromDate ? true : false}
                  onChange={(newDate) =>
                    handleChange(
                      "eventToDate",
                      Number(moment(newDate, "MMM D, YYYY").format("YYYYMMDD"))
                    )
                  }
                />
              ) : eventToDate ? (
                <span className="event-to">
                  {moment(eventState.eventToDate, "YYYYMMDD").format(
                    "MMM D, YYYY"
                  )}
                </span>
              ) : (
                <span className="event-to">----------</span>
              )}
            </div>
          </div>
          <div role="wrapper" className="event-description">
            <label className="label">Description</label>
            {modeState === "edit" ? (
              <textarea
                type={"textarea"}
                name="eventDescription"
                className="event-description"
                placeholder="Enter description here..."
                defaultValue={eventState.eventDescription}
                onChange={({ target: { value } }) =>
                  handleChange("eventDescription", value)
                }
              />
            ) : (
              <span className="event-description">
                {eventState.eventDescription}
              </span>
            )}
          </div>
        </form>
      </div>
      {modeState === "read" && (
        <footer className="read">
          <button
            type="button"
            onClick={() => setModeState("remove")}
            role="button"
            data-action="delete"
          >
            <img src="/img/new-icons/red-trash.svg" />
            Delete
          </button>
          <button
            role="button"
            data-button-type="secondary"
            type="button"
            onClick={() => setModeState("edit")}
          >
            Edit
          </button>
        </footer>
      )}
      {modeState === "edit" && (
        <footer className="edit">
          <button
            type="button"
            onClick={() => handleCancel()}
            role="button"
            data-action="cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            role="button"
            data-button-type="primary"
            onClick={handleUpdate}
            disabled={
              !stateEventName ||
              !stateEventColor ||
              !stateEventFromDate ||
              !stateEventDescription
            }
          >
            Save
          </button>
        </footer>
      )}
      {modeState === "remove" && (
        <footer className="remove">
          <button
            type="button"
            role="button"
            data-action="delete"
            onClick={handleRemoveEvent}
          >
            <img src="/img/new-icons/red-trash.svg" />
            Delete
          </button>
          <button
            type="button"
            role="button"
            data-button-type="tertiary"
            data-action="cancel"
            onClick={() => setModeState("read")}
          >
            Cancel
          </button>
        </footer>
      )}
    </Modal>
  );
};
